<ion-content>
  <ion-list lines="none" class="profile-popover-list">
    <ion-item class="profile-header" lines="none">
      <ion-label>
        <h1>{{ name }}</h1>
        <p>{{ email }}</p>
        @if (roleName) {
          <ion-badge color="medium" class="margin-top-10 role-badge">{{ roleName }}</ion-badge>
        }
      </ion-label>
    </ion-item>

    <ion-item
      button
      [routerLink]="'profile'"
      routerDirection="root"
      (click)="popoverCtrl.dismiss()"
      class="menu-item ion-item-rounded"
    >
      <ion-icon name="person-outline" slot="start" class="menu-icon"></ion-icon>
      <ion-label>Profile</ion-label>
    </ion-item>
    <ion-item
      button
      routerLink="/profile/settings"
      routerDirection="root"
      (click)="popoverCtrl.dismiss()"
      class="menu-item ion-item-rounded"
    >
      <ion-icon name="settings-outline" slot="start" class="menu-icon"></ion-icon>
      <ion-label>Settings</ion-label>
    </ion-item>
    <ion-item
      button
      [routerLink]="'/profile/notifications'"
      routerDirection="root"
      (click)="popoverCtrl.dismiss()"
      class="menu-item ion-item-rounded"
    >
      <ion-icon name="notifications-outline" slot="start" class="menu-icon"></ion-icon>
      <ion-label>Notification settings</ion-label>
    </ion-item>

    @if (authService.integrations.slackEnabled) {
      <ion-item button (click)="openSlackInbox()" class="menu-item ion-item-rounded">
        <ion-icon name="logo-slack" slot="start" class="menu-icon"></ion-icon>
        <ion-label>Slack inbox</ion-label>
        <ion-icon name="open-outline" slot="end" class="menu-icon-end"></ion-icon>
      </ion-item>
    }
    @for (portalLink of portalLinks; track portalLink.url) {
      <ion-item button (click)="openPortal(portalLink.url)" class="menu-item ion-item-rounded">
        <ion-icon name="globe-outline" slot="start" class="menu-icon"></ion-icon>
        <ion-label>{{ portalLink.label }}</ion-label>
        <ion-icon name="open-outline" slot="end" class="menu-icon-end"></ion-icon>
      </ion-item>
    }

    <ion-item-divider class="section-divider"></ion-item-divider>
    <ion-item button (click)="openHelpdesk()" class="menu-item ion-item-rounded">
      <ion-icon name="help-buoy-outline" slot="start" class="menu-icon"></ion-icon>
      <ion-label>Guides & documentation</ion-label>
      <ion-icon name="open-outline" slot="end" class="menu-icon-end"></ion-icon>
    </ion-item>
    <ion-item button (click)="sendFeedback()" class="menu-item ion-item-rounded">
      <ion-icon name="chatbox-ellipses-outline" slot="start" class="menu-icon"></ion-icon>
      <ion-label>Talk to Unthread support</ion-label>
    </ion-item>

    <ion-item-divider class="section-divider"></ion-item-divider>
    <ion-item
      button
      [routerLink]="'login'"
      routerDirection="root"
      (click)="logout()"
      class="menu-item ion-item-rounded"
    >
      <ion-icon name="log-out-outline" slot="start" class="menu-icon" color="danger"></ion-icon>
      <ion-label color="danger">Logout</ion-label>
    </ion-item>
  </ion-list>
</ion-content>
